import {ButtonStyle} from "../config-extractor";

export const defaultButtonStyleValue: Partial<Record<keyof ButtonStyle, string>> = {
    borderStyle: "solid"
};
